/**
 * 表格组件的扩展expand
 */

<template>
    <div id="amgn-expand">
        <Row class="expand-row">
            <Col span="4">
                <span class="expand-key">系统登记联系人: </span>
                <span class="expand-value">{{ row.contactPerson?row.contactPerson:"无" }}</span>
            </Col>
            <Col span="4">
                <span class="expand-key">系统联系人电话: </span>
                <span class="expand-value">{{ row.contact?row.contact:"无" }}</span>
            </Col>
            <Col span="4">
                <span class="expand-key">登陆账号: </span>
                <span class="expand-value">{{ row.account }}</span>
            </Col>
            <Col span="4">
                <span class="expand-key">登陆密码: </span>
                <span class="expand-value">{{ row.pwd }}</span>
            </Col>
            <Col span="4">
                <span class="expand-key">账号更新日期: </span>
                <span class="expand-value">{{ row.date.toString().split(" ")[0] }}</span>
            </Col>
            <Col span="4">
                <span class="expand-key">使用期限(年): </span>
                <span class="expand-value">{{ row.term }}</span>
            </Col>
        </Row>
        <Row class="expand-row">
            <Col span="4">
                <span class="expand-key">机构KEY(数量): </span>
                <span class="expand-value">{{ row.key }}</span>
            </Col>
            <Col span="4">
                <span class="expand-key">机构KEY签章功能: </span>
                <span class="expand-value">{{ row.keyUse }}</span>
            </Col>
            <Col span="8">
                <span class="expand-key">机构KEY保管人员: </span>
                <span class="expand-value">{{ row.keyPerson?row.keyPerson:"无" }}</span>
            </Col>
            <Col span="8">
                <span class="expand-key">备注: </span>
                <span class="expand-value">{{ row.explain?row.explain:"无" }}</span>
            </Col>
        </Row>
    </div>
</template>

<script>
export default {
    props:{
        row:Object
    }
}
</script>

<style lang="less">
#amgn-expand{
    .expand-row{
        margin-bottom: 16px;
    }
    .expand-key{
        font-weight: bold
    }
}
</style>


